import type { Features } from '../constants/bootstrap';
import { PrimaryProductKeys } from '../constants/primary-product-keys';
import type { PrimaryProductKey } from '../constants/product-keys';
import { shouldShowRefreshedFilterRow } from './experiments';

export const getNormalizedFeatures = (
	features: Features | undefined,
	primaryProduct: PrimaryProductKey | undefined,
): Features | undefined => {
	if (primaryProduct === PrimaryProductKeys.Jira && shouldShowRefreshedFilterRow(primaryProduct)) {
		return { ...features, lite: { ...features?.lite, enabled: true } };
	}
	return features;
};
